import React, { useEffect } from 'react';
// import { Suspense, lazy } from 'react'; // Temporarily disabled for ChatBot
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { useSession } from './lib/auth';
import './App.css';
import WelcomePage from './pages/WelcomePage';
import WaitlistPage from './pages/WaitlistPage';
import TeeTimesPage from './pages/TeeTimesPage';
import CoursesPage from './pages/CoursesPage';
import CourseDetailPage from './pages/CourseDetailPage';
import AdminPage from './pages/AdminPage';
import UserDashboard from './pages/UserDashboard';
import ResetPasswordPage from './pages/ResetPasswordPage';

// 懒加载ChatBot组件以减少初始包大小
// const ChatBot = lazy(() => import('./components/chatbot/ChatBot'));

// 内部组件，用于处理登录后重定向
function AppContent() {
  const { data: session } = useSession();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log('🔍 Session状态检查:', {
      sessionExists: !!session,
      userExists: !!session?.user,
      pathname: location.pathname,
      search: location.search
    });


    // 检查是否有保存的重定向路径，并且用户刚刚登录
    const savedPath = sessionStorage.getItem('redirectAfterLogin');
    if (savedPath && session?.user) {
      // 清除保存的路径并重定向
      sessionStorage.removeItem('redirectAfterLogin');
      if (savedPath !== '/') {
        navigate(savedPath);
      }
    }
  }, [session?.user, navigate, location, session]);


  return (
    <>
      <Routes>
        <Route path="/" element={<WelcomePage />} />
        <Route path="/waitlist" element={<WaitlistPage />} />
        <Route path="/tee-times" element={<TeeTimesPage />} />
        <Route path="/courses" element={<CoursesPage />} />
        <Route path="/courses/:id" element={<CourseDetailPage />} />
        <Route path="/dashboard" element={<UserDashboard />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/*" element={<AdminPage />} />
      </Routes>

      {/* ChatBot Assistant - 懒加载以提升性能 */}
      {/* <Suspense fallback={null}>
        <ChatBot
          initialMessage="Hello! I'm your Snag Your Tee golf assistant. I can help you search for courses and tee times."
          theme="light"
        />
      </Suspense> */}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
